<template>
  <div class="form-group" :class="{ row : isOnModeLabelOnLeft }">
    <label
      :for="idComputed"
      :title="titleComputed"
      :class=" {'col-sm-2': isOnModeLabelOnLeft, 'col-form-label': isOnModeLabelOnLeft }"
      class="text-truncate"
      >{{label}} <small v-if="required">*</small></label>
    <div :class="{ 'col-sm-10': isOnModeLabelOnLeft }">
    <input ref="autocomplete"
        type="text"
        class="form-control"
        :class="{'is-invalid': v.$error}"
        :readonly="readonly"
        :placeholder="placeholder"
        :id="idComputed"
        :disabled="disabled"
        :name="name"
        @input="$emit('inputLmGooglePlacesAutocomplete', $event.target.value)"
        @focusout="validateOnfocusOutMethod"
        :value="value"
        autocomplete="off"
      />
    <p class="invalid-feedback" v-if="!v.required"> {{ $t('field_required')}} </p>
    </div>
  </div>
</template>

<script>
import lmInputMixin from '@/mixins/lmInputMixin.js'
export default {
  mixins: [lmInputMixin],
  data () {
    return {
      name: new Date().getTime()
    }
  },
  mounted () {
    // eslint-disable-next-line
    this.autocomplete = new google.maps.places.Autocomplete(
      (this.$refs.autocomplete),
      { types: ['geocode'] }
    )
    this.autocomplete.setComponentRestrictions(this.componentRestrictions)
    this.autocomplete.addListener('place_changed', () => {
      this.$emit('placeChanged', this.autocomplete.getPlace())
    })
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    componentRestrictions: {
      type: Object,
      default: () => ({ country: 'ar' })
    }
  }
}
</script>
